/* Latif's Jewelry: "save this piece" hearts, the saved pieces panel, and recently viewed.
   Everything is kept only in the shopper's own browser; nothing is sent anywhere. */
(function () {
  var SAVED = 'lj_saved_v1';
  var RECENT = 'lj_recent_v1';
  var PHONE = '19546169774';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function read(key) {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  }
  function write(key, value) {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  }
  function handleFrom(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function sized(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var cache = {};
  function product(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { if (!r.ok) throw new Error('gone'); return r.json(); });
    }
    return cache[handle];
  }

  var HEART = '<svg class="lj-heart__icon" viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false"><path d="M12 20.3s-7.6-4.5-9.4-9.1C1.3 7.9 3.3 4.6 6.8 4.6c2.1 0 3.7 1.1 5.2 3 1.5-1.9 3.1-3 5.2-3 3.5 0 5.5 3.3 4.2 6.6-1.8 4.6-9.4 9.1-9.4 9.1z"/></svg>';

  /* ---------- Saved pieces ---------- */
  function saved() { return read(SAVED); }
  function isSaved(h) { return saved().indexOf(h) > -1; }
  function toggle(h) {
    var list = saved();
    var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    write(SAVED, list.slice(0, 60));
    sync();
    return i === -1;
  }
  function sync() {
    var list = saved();
    document.querySelectorAll('[data-lj-save]').forEach(function (b) {
      /* Copies made by the sliding rows don't carry click handlers, so every heart is wired here */
      if (!b.ljBound) {
        b.ljBound = true;
        b.addEventListener('click', onSaveClick);
      }
      var on = list.indexOf(b.getAttribute('data-lj-save')) > -1;
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = b.querySelector('.lj-save-pdp__label');
      var text = on ? 'Saved' : 'Save this piece';
      if (label && label.textContent !== text) label.textContent = text;
    });
    var count = document.querySelector('.lj-saved-count');
    if (count) {
      if (count.textContent !== String(list.length)) count.textContent = list.length;
      count.hidden = list.length === 0;
    }
  }

  function onSaveClick(e) {
    var b = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    var added = toggle(b.getAttribute('data-lj-save'));
    b.classList.remove('lj-pop');
    void b.offsetWidth;
    if (added) b.classList.add('lj-pop');
    var opener = document.getElementById('LjSavedOpen');
    if (added && opener) {
      opener.classList.remove('lj-pop');
      void opener.offsetWidth;
      opener.classList.add('lj-pop');
    }
  }

  function decorateCards(scope) {
    (scope || document).querySelectorAll('.card-wrapper').forEach(function (card) {
      if (card.querySelector('[data-lj-save]')) return;
      var link = card.querySelector('a.full-unstyled-link[href*="/products/"]');
      var h = link && handleFrom(link.getAttribute('href'));
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lj-heart';
      b.setAttribute('data-lj-save', h);
      b.setAttribute('aria-label', 'Save this piece');
      b.setAttribute('aria-pressed', 'false');
      b.innerHTML = HEART;
      /* Sits on the card itself, above the invisible link that makes the whole card clickable */
      card.appendChild(b);
    });
    sync();
  }

  function decorateProductPage() {
    var h = handleFrom(location.pathname);
    var price = document.querySelector('[id^="price-template"]') || document.querySelector('.product__info-container .price');
    if (!h || !price || document.querySelector('.lj-save-pdp')) return;
    var holder = price.closest('[id^="price-"]') || price;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lj-save-pdp';
    b.setAttribute('data-lj-save', h);
    b.setAttribute('aria-pressed', 'false');
    b.innerHTML = HEART + '<span class="lj-save-pdp__label">Save this piece</span>';
    holder.insertAdjacentElement('afterend', b);
    sync();
  }

  /* Header heart that opens the saved panel */
  function buildHeader() {
    var icons = document.querySelector('.header__icons');
    if (!icons || document.getElementById('LjSavedOpen')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.id = 'LjSavedOpen';
    b.className = 'header__icon link focus-inset lj-saved-open';
    b.setAttribute('aria-label', 'Saved pieces');
    b.innerHTML = HEART + '<span class="lj-saved-count" hidden>0</span>';
    b.addEventListener('click', openPanel);
    var cart = icons.querySelector('#cart-icon-bubble');
    icons.insertBefore(b, cart || null);
  }

  var panel = null;
  var lastFocus = null;
  function buildPanel() {
    if (panel) return panel;
    panel = document.createElement('div');
    panel.className = 'lj-drawer';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="lj-drawer__scrim" data-lj-close></div>' +
      '<aside class="lj-drawer__panel" role="dialog" aria-modal="true" aria-labelledby="LjSavedTitle">' +
        '<div class="lj-drawer__head">' +
          '<p class="lj-drawer__eyebrow">Your wish list</p>' +
          '<p id="LjSavedTitle" class="lj-drawer__title">Saved pieces</p>' +
          '<button type="button" class="lj-drawer__close" data-lj-close aria-label="Close">&times;</button>' +
        '</div>' +
        '<ul class="lj-drawer__list" role="list"></ul>' +
        '<p class="lj-drawer__empty">Tap the heart on any piece to keep it here while you decide.</p>' +
        '<div class="lj-drawer__foot">' +
          '<a class="lj-drawer__ask" href="#">Text us about these pieces</a>' +
          '<p class="lj-drawer__note">Saved on this device only.</p>' +
        '</div>' +
      '</aside>';
    document.body.appendChild(panel);
    panel.querySelectorAll('[data-lj-close]').forEach(function (el) { el.addEventListener('click', closePanel); });
    panel.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanel(); });
    return panel;
  }

  function renderPanel() {
    var list = saved();
    var ul = panel.querySelector('.lj-drawer__list');
    var empty = panel.querySelector('.lj-drawer__empty');
    var foot = panel.querySelector('.lj-drawer__foot');
    ul.innerHTML = '';
    empty.hidden = list.length > 0;
    foot.hidden = list.length === 0;
    var lines = [];
    list.forEach(function (h) {
      var li = document.createElement('li');
      li.className = 'lj-drawer__item is-loading';
      ul.appendChild(li);
      product(h).then(function (p) {
        var img = p.featured_image ? '<img src="' + sized(p.featured_image, 200) + '" alt="" width="80" height="80" loading="lazy">' : '';
        li.classList.remove('is-loading');
        li.innerHTML =
          '<a class="lj-drawer__media" href="' + root + 'products/' + esc(h) + '">' + img + '</a>' +
          '<div class="lj-drawer__info">' +
            '<a class="lj-drawer__name" href="' + root + 'products/' + esc(h) + '">' + esc(p.title) + '</a>' +
            '<p class="lj-drawer__price">' + (p.available ? money(p.price) : 'No longer available') + '</p>' +
          '</div>' +
          '<button type="button" class="lj-drawer__remove" aria-label="Remove ' + esc(p.title) + '">Remove</button>';
        li.querySelector('.lj-drawer__remove').addEventListener('click', function () {
          toggle(h);
          renderPanel();
        });
        if (p.available) lines.push(p.title + ' ' + location.origin + root + 'products/' + h);
        updateAsk(lines);
      }).catch(function () {
        li.remove();
      });
    });
  }
  function updateAsk(lines) {
    var a = panel.querySelector('.lj-drawer__ask');
    var body = "Hi Latif's, I'm interested in these pieces:\n" + lines.slice(0, 6).join('\n');
    a.href = 'sms:+' + PHONE + '?&body=' + encodeURIComponent(body);
  }

  function openPanel() {
    buildPanel();
    renderPanel();
    lastFocus = document.activeElement;
    panel.hidden = false;
    document.documentElement.classList.add('lj-drawer-open');
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      panel.querySelector('.lj-drawer__close').focus();
    });
  }
  function closePanel() {
    if (!panel) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('lj-drawer-open');
    setTimeout(function () { panel.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Recently viewed ---------- */
  function rememberView() {
    var h = handleFrom(location.pathname);
    if (!h || !document.querySelector('.product__info-container')) return;
    var list = read(RECENT).filter(function (x) { return x !== h; });
    list.unshift(h);
    write(RECENT, list.slice(0, 16));
  }
  function renderRecent() {
    document.querySelectorAll('[data-lj-recent]').forEach(function (box) {
      var current = box.getAttribute('data-current');
      var max = parseInt(box.getAttribute('data-max'), 10) || 8;
      var handles = read(RECENT).filter(function (h) { return h !== current; }).slice(0, max + 4);
      var ul = box.querySelector('.lj-rv__list');
      if (!handles.length || !ul) return;
      Promise.all(handles.map(function (h) {
        return product(h).then(function (p) { return { h: h, p: p }; }).catch(function () { return null; });
      })).then(function (rows) {
        var shown = 0;
        rows.forEach(function (row) {
          if (!row || !row.p.available || !row.p.featured_image || shown >= max) return;
          shown++;
          var li = document.createElement('li');
          li.className = 'lj-rv__item';
          li.innerHTML =
            '<div class="card-wrapper lj-rv__card">' +
              '<a class="lj-rv__link" href="' + root + 'products/' + esc(row.h) + '">' +
                '<span class="lj-rv__media card__inner"><img src="' + sized(row.p.featured_image, 500) + '" alt="' + esc(row.p.title) + '" loading="lazy" width="500" height="500"></span>' +
                '<span class="lj-rv__name">' + esc(row.p.title) + '</span>' +
                '<span class="lj-rv__price">' + money(row.p.price) + '</span>' +
              '</a>' +
            '</div>';
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lj-heart';
          b.setAttribute('data-lj-save', row.h);
          b.setAttribute('aria-label', 'Save this piece');
          b.innerHTML = HEART;
          li.querySelector('.lj-rv__media').appendChild(b);
          ul.appendChild(li);
        });
        if (shown > 0) box.hidden = false;
        sync();
      });
    });
  }

  function init() {
    buildHeader();
    decorateCards();
    decorateProductPage();
    renderRecent();
    rememberView();
    sync();
    /* Pieces that arrive later (new arrivals feed, filters, endless rows) get hearts too */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; decorateCards(); });
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === SAVED) sync(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
